import { theme } from "../../../App";

const styles = () => ({
  questionWrapper: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
  },

  datePicker: {
    "& .MuiOutlinedInput-adornedStart": {
      paddingLeft: 0,
      height: 48,
    },
    width: 178,
    marginRight: 8,
    "& .MuiOutlinedInput-input": {
      [theme.breakpoints.only("xs")]: {
        padding: "14.3px 16px 14px 16px",
      },
      [theme.breakpoints.up("sm")]: {
        padding: "12.3px 0px",
      },
    },
    "& .MuiIconButton-root": {
      paddingRight: 0,
    },
  },

  paperProps: {
    // '& .MuiPickersModal-dialogRoot':{
    //   position: 'absolute',
    //   bottom: 0,
    //   margin: 0
    // }
  },

  answer: {
    textAlign: "left",
    width: "100%",
    display: "flex",
    alignItems: "flex-start",
    "& .MuiFormControl-marginNormal": {
      marginRight: 20,
      marginTop: 18,
    },

    "& .MuiFormHelperText-contained": {
      marginLeft: 0,
    },

    [theme.breakpoints.only("xs")]: {
      display: "block",
    },
  },

  field: {
    width: "99%",
  },
  textBottomContainer: {
    display: "flex",
    justifyContent: "flex-end",
    color: "rgba(0, 0, 0, 0.54)",
    fontSize: 13,
    marginTop: "-7px",
    width: "99%",
  },
  helperText: {
    flexGrow: 50,
  },
  limitWarning: {
    color: "#c53929",
  },
  counterBox: {
    marginLeft: 15,
    minWidth: 49,
    textAlign: "right",
  },
  textArea: {
    width: "100%",
    minHeight: "100px !important",
    borderRadius: 4,
    border: "1px solid #dadce0",
    paddingLeft: 10,
    fontSize: 16,
    "&:focus": {
      outline: "none !important",
      border: (props) => `1px solid ${props.currentTheme.primaryColor}`,
    },
  },
  paperPosition: {
    "& .MuiPopover-paper": {
      // width: "100%",
      // top:'50vh',
      // position: 'fixed'
    },
  },
  errorContainer: {
    display: "flex",
    alignItems: "center",
  },
});

export default styles;
